module.exports = __webpack_public_path__ + "static/media/wizualizacja-137.bbf756d0.png";